export default __webpack_public_path__ + "static/media/Bhojpuri_health_f.722c9755.wav";